import { Navigate } from "react-router-dom";

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

//old project
import AdsList from "pages/AdsManagement/AdsList";
import BoostAds from "pages/AdsManagement/BoostAds";
import AdPackage from "pages/AdsManagement/Package";
import AgencyList from "pages/Agency/AgencyList";
import CampaignList from "pages/Agency/Campaign";
import EventTracking from "pages/Agency/EventTracking";
import BarList from "pages/BarList";
import Reservation from "pages/BarManagement/Reservation";
import ChatLogList from "pages/ChatLog";
import Feed from "pages/ContentManagement/Feed";
import Wink from "pages/ContentManagement/Wink";
import CouponActionLog from "pages/CouponManagement/CouponActionLog";
import CouponIssue from "pages/CouponManagement/CouponIssue";
import EventLogNew from "pages/DuplicateLog/EventLog";
import LocationLogNew from "pages/DuplicateLog/LocationLog";
import EventLog from "pages/EventLog";
import HashTag from "pages/HashTag";
import LocationLog from "pages/LocationLog";
import ReferralLog from "pages/ReferralLog";
import ManualPush from "pages/PushNotification/ManualPush";
import PushLog from "pages/PushNotification/PushLog";
import AcquisitionStatistics from "pages/Statistics/AcquisitionStatistics";
import AdsPerformanceStatistics from "pages/Statistics/AdsPerformanceStatistics";
import ArtistRegistrationStatus from "pages/Statistics/ArtistRegistrationStatus";
import BaiverRegistrationStatus from "pages/Statistics/BaiverRegistrationStatus";
import BarStatistics from "pages/Statistics/BarStatistics";
import CaptainRegistrationStatus from "pages/Statistics/CaptainRegistrationStatus";
import ContentUsageStatus from "pages/Statistics/ContentUsageStatus";
import DailyUserStatistics from "pages/Statistics/DailyUserStatistics";
import PushStatistics from "pages/Statistics/PushStatistics";
import RegionalCityStatistics from "pages/Statistics/RegionalCityStatistics";
import RegionalTownStatistics from "pages/Statistics/RegionalTownStatistics";
import TrafficStatistics from "pages/Statistics/TrafficStatistics";
import StickerManagement from "pages/StickerManagement";
import BartenderUserList from "pages/User/BartenderUserList";
import Customer from "pages/User/Customer";
import StoreManager from "pages/User/StoreManager";
import AppSetting from "pages/Setting/AppSetting";
import Inquiry from "pages/Inquiry";

import OperatorList from "pages/Operator/Operator";
import Profile from "pages/Operator/Profile";
import RoleList from "pages/Operator/Role";
import ActivityLogList from "pages/Operator/ActivityLog";
import ReferralRules from "pages/Referral/Rule";
import ReferralRewards from "pages/Referral/Reward";
import VOCReasons from "pages/VOC/VOCReason";
import VOCList from "pages/VOC/VOCList";
import ReferralTriggerEvents from "pages/Referral/TriggerEvent";
import RequestWithdraw from "pages/RequestWithdraw";

const ROUTES = {
  LOGIN: "/login",
  LOGOUT: "/logout",

  HOME: "/",

  BAR_LIST: "/store-management/store",
  HASHTAG_MANAGEMENT: "/store-management/hashtag",

  STORE_MANAGEMENT: "/user-management/manager",
  BARTENDER_USER_LIST: "/user-management/bartender",
  CUSTOMER: "/user-management/user",

  WINK: "/content-management/wink",
  STICKER_MANAGEMENT: "/content-management/sticker",

  DASHBOARD: "/dashboard",
  PROFILE: "/profile",
  PROFILE_SETTING: "/pages-profile-settings",

  LOGIN_HISTORY: "/user/login_history",
  USER_FEEDBACK: "/user/user_feedback",

  LOCATION_LOG: "/log/location-log",
  EVENT_LOG: "/log/event-log",
  CHAT_LOG: "/log/chat-log",
  REFERRAL_LOG: "/log/referral-log",

  AGENCY_LIST_MANAGEMENT: "/agency-management/agency",
  AGENCY_EVENT_TRACKING: "/agency-management/event-tracking-logs",
  AGENCY_CAMPAIGN: "/agency-management/campaign",

  COUPON_ISSUE: "/coupon-management/coupon-issue",
  COUPON_ACTION_LOG: "/coupon-management/coupon-action-log",

  INQUIRY_LIST: "/inquiry-management",

  TRAFFIC_STATISTIC: "/statistics/content",
  ADS_PERFORMANCE_STATISTIC: "/statistics/baive-ads",
  CONTENT_USAGE_STATUS_STATISTIC: "/statistics/content-usage-status",
  CAPTAIN_REGISTRATION_STATUS_STATISTIC:
    "/statistics/captain-registration-status",
  ARTIST_REGISTRATION_STATUS_STATISTIC:
    "/statistics/artist-registration-status",
  BAIVER_REGISTRATION_STATUS_STATISTIC:
    "/statistics/baiver-registration-status",

  PUSH_NOTIFICATION_PUSH_LOG: "/push-notification/push-log",
  PUSH_NOTIFICATION_MANUAL_PUSH: "/push-notification/manual-push",

  STATISTICS_DAILY_USER: "/statistics/daily-statistics",
  STATISTICS_PUSH: "/statistics/push",
  STATISTICS_BAR: "/statistics/bar",
  STATISTICS_ACQUISITION: "/statistics/acquisition",
  STATISTICS_REGIONAL_CITY: "/statistics/regional-city",
  STATISTICS_REGIONAL_TOWN: "/statistics/regional-town",

  SETTING: "/setting-management",

  OPERATOR_LIST: "/operator-management/list",
  OPERATOR_ROLE: "/operator-management/role",
  OPERATOR_ACTIVITY_LOG: "/operator-management/activity-logs",
  OPERATOR_PROFILE: "/operator-management/profile",

  REFERRAL_RULES: "/referral-management/rules",
  REFERRAL_REWARDS: "/referral-management/rewards",
  REFERRAL_TRIGGER_EVENT: "/referral-management/trigger-event",

  VOC_REASON: "/voc-management/reason",
  VOC_LIST: "/voc-management/list",

  REQUEST_WITHDRAW: "/request-withdraw",

  ////////////// === BEGIN: Menu don't be use ===//////////////
  FEED: "/feed", //
  CHAT_CONTENT: "/chat-content", //

  RESERVATION_STATUS: "/reservation-status", //
  ADS_MANAGEMENT: "/ads-management", //

  LOCATION_LOG_NEW: "/location-log-migration", //
  EVENT_LOG_NEW: "/event-log-migration", //

  AD_PACKAGE: "/ad-package", //
  AD_LIST: "/ad-list", //
  BOOST_AD: "/boost_ad", //

  REVENUE_STATUS: "/revenue-status", //
  PAYMENT_HISTORY: "/payment-history", //
  AUTOMATIC_REPORT_GENERATION: "/automatic-report-generation", //
  ////////////// === END: Menu don't be use ===//////////////
  APP_SETTING: "/app-setting",
};

const ROUTE_NAMES = [
  {
    link: ROUTES.LOGIN,
    name: "Login",
  },
  {
    link: ROUTES.LOGOUT,
    name: "Logout",
  },
  {
    link: ROUTES.WINK,
    name: "Wink",
  },
  {
    link: ROUTES.STICKER_MANAGEMENT,
    name: "Sticker",
  },
  {
    link: ROUTES.STORE_MANAGEMENT,
    name: "Manager",
  },
  {
    link: ROUTES.BARTENDER_USER_LIST,
    name: "Bartender",
  },
  {
    link: ROUTES.CUSTOMER,
    name: "User",
  },
  {
    link: ROUTES.OPERATOR_LIST,
    name: "Operator",
  },
  {
    link: ROUTES.OPERATOR_ROLE,
    name: "Role",
  },
  {
    link: ROUTES.OPERATOR_ACTIVITY_LOG,
    name: "Activity Logs",
  },
  {
    link: ROUTES.BAR_LIST,
    name: "Store",
  },
  {
    link: ROUTES.HASHTAG_MANAGEMENT,
    name: "Hashtag",
  },
  {
    link: ROUTES.AGENCY_LIST_MANAGEMENT,
    name: "Agency",
  },
  {
    link: ROUTES.AGENCY_CAMPAIGN,
    name: "Campaign",
  },
  {
    link: ROUTES.AGENCY_EVENT_TRACKING,
    name: "Event Tracking Logs",
  },
  {
    link: ROUTES.COUPON_ISSUE,
    name: "Coupon Issue",
  },
  {
    link: ROUTES.COUPON_ACTION_LOG,
    name: "Coupon Action Log",
  },
  {
    link: ROUTES.INQUIRY_LIST,
    name: "Inquiry",
  },
  {
    link: ROUTES.PUSH_NOTIFICATION_PUSH_LOG,
    name: "Push Log",
  },
  {
    link: ROUTES.PUSH_NOTIFICATION_MANUAL_PUSH,
    name: "Send Push (Manual)",
  },
  {
    link: ROUTES.STATISTICS_ACQUISITION,
    name: "Acquisition Statistics",
  },
  {
    link: ROUTES.STATISTICS_DAILY_USER,
    name: "Daily Statistics",
  },
  {
    link: ROUTES.STATISTICS_REGIONAL_CITY,
    name: "Regional Statistics (City)",
  },
  {
    link: ROUTES.STATISTICS_REGIONAL_TOWN,
    name: "Regional Statistics (Town)",
  },
  {
    link: ROUTES.STATISTICS_BAR,
    name: "Store Statistics",
  },
  {
    link: ROUTES.STATISTICS_PUSH,
    name: "Push Statistics",
  },
  {
    link: ROUTES.LOCATION_LOG,
    name: "Location Log",
  },
  {
    link: ROUTES.REFERRAL_LOG,
    name: "Referral Log",
  },
  {
    link: ROUTES.EVENT_LOG,
    name: "Event Log",
  },
  {
    link: ROUTES.CHAT_LOG,
    name: "Chat Log",
  },
  {
    link: ROUTES.REFERRAL_RULES,
    name: "Invitation Rules",
  },
  {
    link: ROUTES.REFERRAL_REWARDS,
    name: "Invitation Reward Details",
  },
  {
    link: ROUTES.REFERRAL_TRIGGER_EVENT,
    name: "Reward Distribution Settings",
  },
  {
    link: ROUTES.REQUEST_WITHDRAW,
    name: "Request Withdraw",
  },
  {
    link: ROUTES.APP_SETTING,
    name: "App Setting",
  },
];

const authProtectedRoutes = [
  { path: ROUTES.FEED, component: <Feed /> },
  { path: ROUTES.WINK, component: <Wink /> },
  { path: ROUTES.BAR_LIST, component: <BarList /> },
  { path: ROUTES.RESERVATION_STATUS, component: <Reservation /> },
  { path: ROUTES.STORE_MANAGEMENT, component: <StoreManager /> },
  { path: ROUTES.BARTENDER_USER_LIST, component: <BartenderUserList /> },
  { path: ROUTES.CUSTOMER, component: <Customer /> },
  { path: ROUTES.AD_PACKAGE, component: <AdPackage /> },
  { path: ROUTES.AD_LIST, component: <AdsList /> },
  { path: ROUTES.BOOST_AD, component: <BoostAds /> },
  { path: ROUTES.STICKER_MANAGEMENT, component: <StickerManagement /> },
  { path: ROUTES.HASHTAG_MANAGEMENT, component: <HashTag /> },

  { path: ROUTES.LOCATION_LOG, component: <LocationLogNew /> },
  { path: ROUTES.REFERRAL_LOG, component: <ReferralLog /> },
  { path: ROUTES.EVENT_LOG, component: <EventLogNew /> },
  { path: ROUTES.CHAT_LOG, component: <ChatLogList /> },
  { path: ROUTES.LOCATION_LOG_NEW, component: <LocationLog /> },
  { path: ROUTES.EVENT_LOG_NEW, component: <EventLog /> },

  { path: ROUTES.REVENUE_STATUS, component: <></> },
  { path: ROUTES.PAYMENT_HISTORY, component: <></> },
  { path: ROUTES.AUTOMATIC_REPORT_GENERATION, component: <></> },

  { path: ROUTES.TRAFFIC_STATISTIC, component: <TrafficStatistics /> },
  {
    path: ROUTES.ADS_PERFORMANCE_STATISTIC,
    component: <AdsPerformanceStatistics />,
  },
  {
    path: ROUTES.CONTENT_USAGE_STATUS_STATISTIC,
    component: <ContentUsageStatus />,
  },
  {
    path: ROUTES.CAPTAIN_REGISTRATION_STATUS_STATISTIC,
    component: <CaptainRegistrationStatus />,
  },
  {
    path: ROUTES.ARTIST_REGISTRATION_STATUS_STATISTIC,
    component: <ArtistRegistrationStatus />,
  },
  {
    path: ROUTES.BAIVER_REGISTRATION_STATUS_STATISTIC,
    component: <BaiverRegistrationStatus />,
  },

  { path: ROUTES.SETTING, component: <></> },

  { path: ROUTES.AGENCY_LIST_MANAGEMENT, component: <AgencyList /> },
  { path: ROUTES.AGENCY_EVENT_TRACKING, component: <EventTracking /> },
  { path: ROUTES.AGENCY_CAMPAIGN, component: <CampaignList /> },

  { path: ROUTES.COUPON_ISSUE, component: <CouponIssue /> },
  { path: ROUTES.COUPON_ACTION_LOG, component: <CouponActionLog /> },

  { path: ROUTES.INQUIRY_LIST, component: <Inquiry /> },

  { path: ROUTES.PUSH_NOTIFICATION_PUSH_LOG, component: <PushLog /> },
  { path: ROUTES.PUSH_NOTIFICATION_MANUAL_PUSH, component: <ManualPush /> },

  { path: ROUTES.STATISTICS_DAILY_USER, component: <DailyUserStatistics /> },
  { path: ROUTES.STATISTICS_PUSH, component: <PushStatistics /> },
  { path: ROUTES.STATISTICS_BAR, component: <BarStatistics /> },
  { path: ROUTES.STATISTICS_ACQUISITION, component: <AcquisitionStatistics /> },
  {
    path: ROUTES.STATISTICS_REGIONAL_CITY,
    component: <RegionalCityStatistics />,
  },
  {
    path: ROUTES.STATISTICS_REGIONAL_TOWN,
    component: <RegionalTownStatistics />,
  },
  { path: ROUTES.APP_SETTING, component: <AppSetting /> },

  { path: ROUTES.OPERATOR_LIST, component: <OperatorList /> },
  { path: ROUTES.OPERATOR_ROLE, component: <RoleList /> },
  { path: ROUTES.OPERATOR_ACTIVITY_LOG, component: <ActivityLogList /> },
  { path: ROUTES.OPERATOR_PROFILE, component: <Profile /> },

  { path: ROUTES.REFERRAL_RULES, component: <ReferralRules /> },
  { path: ROUTES.REFERRAL_REWARDS, component: <ReferralRewards /> },
  { path: ROUTES.REFERRAL_TRIGGER_EVENT, component: <ReferralTriggerEvents /> },

  { path: ROUTES.VOC_REASON, component: <VOCReasons /> },
  { path: ROUTES.VOC_LIST, component: <VOCList /> },

  { path: ROUTES.REQUEST_WITHDRAW, component: <RequestWithdraw /> },

  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to={ROUTES.WINK} />,
  },
  { path: "*", component: <Navigate to={ROUTES.WINK} /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
];

export { authProtectedRoutes, publicRoutes, ROUTES, ROUTE_NAMES };
